export default [
  {
    title: 'Admin.SideMenu.AdTypes',
    icon: 'UnorderedList',
    children: [
      {
        title: 'Admin.SideMenu.DisplayAds',
        route: 'admin-displayads',
      },
      {
        title: 'Admin.SideMenu.NativeAds',
        route: 'admin-nativeads',
      },
      {
        title: 'Admin.SideMenu.AdFormats',
        route: 'ad-formats',
      },
    ],
  },
]
